export function LegendPie({ color }: { color: string }) {
	return (
		<svg width="3" height="16" viewBox="0 0 3 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="3" height="16" rx="1.5" fill={color} />
		</svg>
	);
}
